import { render, staticRenderFns } from "./IndexBannerItem.vue?vue&type=template&id=fd2ef1c6&scoped=true&"
import script from "./IndexBannerItem.vue?vue&type=script&lang=js&"
export * from "./IndexBannerItem.vue?vue&type=script&lang=js&"
import style0 from "styles/views/index/indexbanneritem.css?vue&type=style&index=0&id=fd2ef1c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2ef1c6",
  null
  
)

export default component.exports